//// Application Packages
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import { selectForms } from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { TextInput, Button } from '@carbon/react'

//// Carbon Icons
import { Subtract } from '@carbon/icons-react'

//// Static Constants

//////// Component
const AdditionalNameAndPersonalDetailsComponent = ({
    number,
    handleData,
    handleSubtractAdditionalNameAndPersonalDetailsComponent,
}) => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <h4>Additional Name:</h4>

            <TextInput
                className="required"
                labelText="First Name:"
                id={'frst_nme' + number}
                name={'frst_nme' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['frst_nme' + number]}
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.['frst_nme' + number]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'frst_nme' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                labelText="Middle Name:"
                id={'sec_nme' + number}
                name={'sec_nme' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['sec_nme' + number]}
                type="text"
                onChange={handleData}
                invalid={
                    formsData?.[digital_name]?.errors?.['sec_nme' + number]
                }
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'sec_nme' + number + 'ErrMsg'
                    ]
                }
            />

            <TextInput
                className="required"
                labelText="Last Name:"
                id={'surnme' + number}
                name={'surnme' + number}
                placeholder=""
                value={formsData?.[digital_name]?.values?.['surnme' + number]}
                type="text"
                onChange={handleData}
                invalid={formsData?.[digital_name]?.errors?.['surnme' + number]}
                invalidText={
                    formsData?.[digital_name]?.errors?.[
                        'surnme' + number + 'ErrMsg'
                    ]
                }
            />

            <div className="half-width-button-with-icon-group">
                <div className="half-width-button-with-icon-group-item">
                    <Button
                        className="fldoh-btn"
                        name={number}
                        type="button"
                        kind="danger"
                        size="md"
                        onClick={
                            handleSubtractAdditionalNameAndPersonalDetailsComponent
                        }
                    >
                        Remove
                        <Subtract />
                    </Button>
                </div>
            </div>
        </>
    )
}

export default AdditionalNameAndPersonalDetailsComponent
